import { setLogosErrors } from "../../store/slices/errors";
import apiClient from "../../utils/api.client";
import { getNoaId, getOrganizationId } from "../../utils/session.utils";

const serviceName = "api-themes";

const logoBaseOnOrgId = async () => {
  
  const noaId = getNoaId();
  try {
    const response = await fetch(
      `/${noaId}/api-themes/themes/logo/getCurrentLogo/${noaId}`,
    );
    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error at logoBaseOnOrgId EP: ", error);
    throw error;
  }
};
const getAllThemes = async () => {

  const noaId = getNoaId();
  try {
    const response = await apiClient.get(`${serviceName}/themes/pallete?organizationId=${noaId}`);
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at getAllThemes EP: ", e);
    throw e;
  }
};

const currentTheme = async (organizationid = getOrganizationId()) => {
  try {
    const response = await apiClient.get(
      `/api-themes/themes/pallete/getCurrentThemes/${organizationid}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at currentTheme EP: ", error);
    throw error;
  }
};

const addNewTheme = async (payload) => {
  try {
    const response = await apiClient.post(
      `${serviceName}/themes/pallete`,
      payload,
    );
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at addNewTheme EP: ", e);
    throw e;
  }
};

const editTheme = async (payload) => {
  try {
    const response = await apiClient.put(
      `${serviceName}/themes/pallete`,
      payload,
    );
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at editTheme EP: ", e);
    throw e;
  }
};

const deleteTheme = async (themeId) => {
  try {
    const response = await apiClient.delete(
      `${serviceName}/themes/pallete/${themeId}`,
    );
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at deleteTheme EP: ", e);
    throw e;
  }
};

const setDefaultTheme = async (themeId) => {
  const payload = {
    id: themeId,
    organizationId: getNoaId(),
    defaultP: true,
  };

  try {
    const response = await apiClient.post(
      `${serviceName}/themes/pallete/setdefault`,
      payload,
    );
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at setDefaultTheme EP: ", e);
    throw e;
  }
};

const setCurrentTheme = async (themeId, organizationId) => {
  let payload = {
    id: themeId,
    organizationId: organizationId,
    current: true,
  };
  try {
    const response = await apiClient.post(
      `${serviceName}/themes/pallete/setcurrent`,
      payload,
    );
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at setCurrentTheme EP: ", e);
    throw e;
  }
};

const getAllLogos = async (dispatch) => {
  const noaId = getNoaId();
  try {
    const response = await apiClient.get(
      `${serviceName}/themes/logo?organizationId=${noaId}`,
    );
    const data = response.data;
    dispatch(setLogosErrors({ error: false }));

    return data;
  } catch (e) {
    console.log(e);
    dispatch(setLogosErrors({ error: true, code: e.status || e.message }));
    throw e;
  }
};

const setDefaultLogo = async (logoId, organizationId) => {
  let payload = {
    id: logoId,
    organizationId: organizationId,
    defaultL: true,
  };
  try {
    const response = await apiClient.post(
      `${serviceName}/themes/logo/setdefault`,
      payload,
    );
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at setDefaultLogo EP: ", e);
    throw e;
  }
};

const addNewLogo = async (payload) => {
  try {
    const response = await apiClient.post(
      `${serviceName}/themes/logo`,
      payload,
    );
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at addNewLogo EP: ", e);
    throw e;
  }
};

const editLogo = async (payload) => {
  try {
    const response = await apiClient.put(`${serviceName}/themes/logo`, payload);
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at editLogo EP: ", e);
    throw e;
  }
};

const deleteLogo = async (logoId) => {
  try {
    const response = await apiClient.delete(
      `${serviceName}/themes/logo/${logoId}`,
    );
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at deleteLogo EP: ", e);
    throw e;
  }
};

const currentLogo = async (organizationid = getOrganizationId()) => {
  const noaId = getNoaId();
  try {
    const response = await apiClient.get(
      `/api-themes/themes/logo/getCurrentLogo/${organizationid ? organizationid : noaId}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at currentLogo EP: ", error);
    throw error;
  }
};

const setCurrentLogo = async (logoId) => {
  let payload = {
    id: logoId,
    organizationId: getNoaId(),
    current: true,
  };
  try {
    const response = await apiClient.post(
      `${serviceName}/themes/logo/setcurrent`,
      payload,
    );
    const data = response.data;

    return data;
  } catch (e) {
    console.error("Error at setCurrentLogo EP: ", e);
    throw e;
  }
};

const themeService = {
  getAllThemes,
  logoBaseOnOrgId,
  setCurrentTheme,
  setDefaultTheme,
  addNewTheme,
  editTheme,
  deleteTheme,
  currentTheme,
  getAllLogos,
  setDefaultLogo,
  addNewLogo,
  editLogo,
  deleteLogo,
  currentLogo,
  setCurrentLogo,
};

export default themeService;
